import { Component, HostBinding, Input } from '@angular/core';
import { EntityIdentifierHelper, Invitation, MemberView } from '@fairandsmart/types';
import { FsAngularDirectivesModule } from '@fairandsmart/angular/directives';
import { NgClass } from '@angular/common';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';

@Component({
    selector: 'fs-organisation-member',
    templateUrl: 'organisation-member.component.html',
    styleUrls: ['./organisation-member.component.scss'],
    imports: [FsAngularDirectivesModule, NgClass, MatChipListbox, MatChipOption]
})
export class OrganisationMemberComponent {
  @Input()
    member: MemberView;

  @Input()
    invite: Invitation;

  @Input()
    showRoles = false;

  @Input()
    showAvatar = true;

  @Input()
  @HostBinding('class.dense')
    dense: boolean;

  @Input()
    avatarSize: number = null;

  @Input()
  @HostBinding('class.fs-disabled')
    disabled = false;

  @Input()
  @HostBinding('class.fs-selectable')
    selectable = false;

  @Input()
  @HostBinding('class.fs-selected')
    selected = false;

  get userId() {
    return this.member?.userid || null;
  }

  get username() {
    return this.member?.username || null;
  }

  get email() {
    // @ts-ignore
    return this.member?.email || (this.invite ? EntityIdentifierHelper.extractId(this.invite.target) : null);
  }

  get roles() {
    return this.member?.roles || this.invite.params.MEMBER_ROLES.split(',');
  }
}
